export class MethodUtils {
	public static callAndReturnValue = <ValueType>(fn: Function, value: ValueType): ValueType => {
		fn?.();
		return value;
	};
}
